// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global reset and font */
body {
  margin: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background: #ffffff; /* D7FD34 */
  color: #333;
}

/* Container for pages */
.container {
  /* max-width: 960px; */
  margin: 30px auto;
  padding: 0 20px;
}

/* Buttons */
button {
  background-color: #624545;
  color: white;
  border: none;
  padding: 10px 18px;
  font-size: 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-bottom: 20px;
}
button:hover {
  background-color: #357ABD;
}

/* Admin orders table */
table {
  width: 100%;
  border-collapse: collapse;
  box-shadow: 0 2px 8px rgb(0 0 0 / 0.1);
  background: white;
  border-radius: 6px;
  overflow: hidden;
}

thead {
  background-color: #4a90e2;
  color: white;
}

th, td {
  text-align: center;
  padding: 12px 15px;
  border-bottom: 1px solid #ddd;
  font-size: 0.95rem;
}

tbody tr:nth-child(even) {
  background-color: #f3f6fc;
}

tbody tr:hover {
  background-color: #dbe9fb;
}

td ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

td ul li {
  margin-bottom: 4px;
  font-size: 0.9rem;
  color: #555;
}

/* Home page card with photo */
.home-card {
  display: flex;
  background: white;
  border-radius: 10px;
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.12);
  overflow: hidden;
  margin-bottom: 30px;
  align-items: center;
}

.home-card img {
  width: 250px;
  object-fit: cover;
  border-right: 1px solid #eee;
  height: 180px;
}

.home-card-content {
  padding: 20px;
}

.home-card-content h2 {
  margin-top: 0;
  color: #4a90e2;
}

.home-card-content p {
  margin: 6px 0;
  font-size: 1rem;
  color: #444;
}

.home-card-content a {
  color: #357ABD;
  text-decoration: none;
  font-weight: 600;
}
.home-card-content a:hover {
  text-decoration: underline;
}

/* Responsive tweaks */
@media (max-width: 600px) {
  .home-card {
    flex-direction: column;
  }
  .home-card img {
    width: 100%;
    height: auto;
    border-right: none;
    border-bottom: 1px solid #eee;
  }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.btn-mail {
  background-color: #4caf50;
  color: white;
  padding: 5px 10px;
  border: none;
  cursor: pointer;
  border-radius: 4px;
}

.btn-mail:hover {
  background-color: #45a049;
}

.btn-mail,
.btn-sms {
  padding: 5px 10px;
  margin: 2px;
  border: none;
  border-radius: 5px;
  color: white;
  background-color: #4caf50;
  cursor: pointer;
}
.btn-sms {
  background-color: #2196f3;
}

select {
  padding: 6px 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 0.9rem;
  background: #fff;
  min-width: 120px;
}

tbody tr.order-closed:nth-child(even),
tbody tr.order-closed:nth-child(odd) {
  background-color: #494949;
  color: #888;
  opacity: 0.6;
}

/* Affiche uniquement le lien vers les produits en responsive */
.lien-produits-responsive {
  display: none;
}

@media (max-width: 1024px) {
  .lien-produits-responsive {
    display: block;
    text-align: center;
  }
  
  .product-image {
    max-width: 100% !important;
    max-height: 50px !important;
  }
}

html {
  scroll-behavior: smooth;
}

.legend {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
  align-items: center;
  font-size: 0.95rem;
  flex-wrap: wrap;
}

.legend-item {
  padding: 6px 12px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: default;
  font-weight: 500;
}

.legend-item.order-closed {
  background-color: #494949;
  color: #ccc;
  opacity: 0.8;
}

.legend-item.order-ready-cse {
  background-color: #d7fd34;
  color: #333;
}

/* Couleurs unifiées pour les commandes */
.order-status-closed {
  background-color: #494949 !important;
  color: #ccc !important;
  opacity: 0.8;
}

.order-status-ready-cse {
  background-color: #45fd34 !important;
  color: #333 !important;
}

input:required:invalid {
  border: 2px solid #fccbc5 !important;
  background-color: #fff6f6 !important;
}

/* input:required:valid {
  border: 2px solid #2ecc71 !important;
} */

.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  background-color: #ccc;
  border-radius: 24px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  border-radius: 50%;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #4caf50;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

.product-image {
  max-width: 100%;
  max-height: 100%;
  text-align: 'center';
  object-fit: 'cover';
  border-radius: 4;
  cursor: 'pointer';
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,SAAS;EACT,4DAA4D;EAC5D,mBAAmB,EAAE,WAAW;EAChC,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,yBAAyB;EACzB,sCAAsC;EACtC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;EAC/B;AACF;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA,+DAA+D;AAC/D;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,yCAAyC;AACzC;EACE,oCAAoC;EACpC,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;;GAEG;;AAEH;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["/* Global reset and font */\r\nbody {\r\n  margin: 0;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  background: #ffffff; /* D7FD34 */\r\n  color: #333;\r\n}\r\n\r\n/* Container for pages */\r\n.container {\r\n  /* max-width: 960px; */\r\n  margin: 30px auto;\r\n  padding: 0 20px;\r\n}\r\n\r\n/* Buttons */\r\nbutton {\r\n  background-color: #624545;\r\n  color: white;\r\n  border: none;\r\n  padding: 10px 18px;\r\n  font-size: 1rem;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n  margin-bottom: 20px;\r\n}\r\nbutton:hover {\r\n  background-color: #357ABD;\r\n}\r\n\r\n/* Admin orders table */\r\ntable {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  box-shadow: 0 2px 8px rgb(0 0 0 / 0.1);\r\n  background: white;\r\n  border-radius: 6px;\r\n  overflow: hidden;\r\n}\r\n\r\nthead {\r\n  background-color: #4a90e2;\r\n  color: white;\r\n}\r\n\r\nth, td {\r\n  text-align: center;\r\n  padding: 12px 15px;\r\n  border-bottom: 1px solid #ddd;\r\n  font-size: 0.95rem;\r\n}\r\n\r\ntbody tr:nth-child(even) {\r\n  background-color: #f3f6fc;\r\n}\r\n\r\ntbody tr:hover {\r\n  background-color: #dbe9fb;\r\n}\r\n\r\ntd ul {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\ntd ul li {\r\n  margin-bottom: 4px;\r\n  font-size: 0.9rem;\r\n  color: #555;\r\n}\r\n\r\n/* Home page card with photo */\r\n.home-card {\r\n  display: flex;\r\n  background: white;\r\n  border-radius: 10px;\r\n  box-shadow: 0 3px 10px rgb(0 0 0 / 0.12);\r\n  overflow: hidden;\r\n  margin-bottom: 30px;\r\n  align-items: center;\r\n}\r\n\r\n.home-card img {\r\n  width: 250px;\r\n  object-fit: cover;\r\n  border-right: 1px solid #eee;\r\n  height: 180px;\r\n}\r\n\r\n.home-card-content {\r\n  padding: 20px;\r\n}\r\n\r\n.home-card-content h2 {\r\n  margin-top: 0;\r\n  color: #4a90e2;\r\n}\r\n\r\n.home-card-content p {\r\n  margin: 6px 0;\r\n  font-size: 1rem;\r\n  color: #444;\r\n}\r\n\r\n.home-card-content a {\r\n  color: #357ABD;\r\n  text-decoration: none;\r\n  font-weight: 600;\r\n}\r\n.home-card-content a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Responsive tweaks */\r\n@media (max-width: 600px) {\r\n  .home-card {\r\n    flex-direction: column;\r\n  }\r\n  .home-card img {\r\n    width: 100%;\r\n    height: auto;\r\n    border-right: none;\r\n    border-bottom: 1px solid #eee;\r\n  }\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n@keyframes spin {\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n.btn-mail {\r\n  background-color: #4caf50;\r\n  color: white;\r\n  padding: 5px 10px;\r\n  border: none;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n}\r\n\r\n.btn-mail:hover {\r\n  background-color: #45a049;\r\n}\r\n\r\n.btn-mail,\r\n.btn-sms {\r\n  padding: 5px 10px;\r\n  margin: 2px;\r\n  border: none;\r\n  border-radius: 5px;\r\n  color: white;\r\n  background-color: #4caf50;\r\n  cursor: pointer;\r\n}\r\n.btn-sms {\r\n  background-color: #2196f3;\r\n}\r\n\r\nselect {\r\n  padding: 6px 10px;\r\n  border-radius: 5px;\r\n  border: 1px solid #ccc;\r\n  font-size: 0.9rem;\r\n  background: #fff;\r\n  min-width: 120px;\r\n}\r\n\r\ntbody tr.order-closed:nth-child(even),\r\ntbody tr.order-closed:nth-child(odd) {\r\n  background-color: #494949;\r\n  color: #888;\r\n  opacity: 0.6;\r\n}\r\n\r\n/* Affiche uniquement le lien vers les produits en responsive */\r\n.lien-produits-responsive {\r\n  display: none;\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .lien-produits-responsive {\r\n    display: block;\r\n    text-align: center;\r\n  }\r\n  \r\n  .product-image {\r\n    max-width: 100% !important;\r\n    max-height: 50px !important;\r\n  }\r\n}\r\n\r\nhtml {\r\n  scroll-behavior: smooth;\r\n}\r\n\r\n.legend {\r\n  display: flex;\r\n  gap: 15px;\r\n  margin-bottom: 20px;\r\n  align-items: center;\r\n  font-size: 0.95rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.legend-item {\r\n  padding: 6px 12px;\r\n  border-radius: 4px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  cursor: default;\r\n  font-weight: 500;\r\n}\r\n\r\n.legend-item.order-closed {\r\n  background-color: #494949;\r\n  color: #ccc;\r\n  opacity: 0.8;\r\n}\r\n\r\n.legend-item.order-ready-cse {\r\n  background-color: #d7fd34;\r\n  color: #333;\r\n}\r\n\r\n/* Couleurs unifiées pour les commandes */\r\n.order-status-closed {\r\n  background-color: #494949 !important;\r\n  color: #ccc !important;\r\n  opacity: 0.8;\r\n}\r\n\r\n.order-status-ready-cse {\r\n  background-color: #45fd34 !important;\r\n  color: #333 !important;\r\n}\r\n\r\ninput:required:invalid {\r\n  border: 2px solid #fccbc5 !important;\r\n  background-color: #fff6f6 !important;\r\n}\r\n\r\n/* input:required:valid {\r\n  border: 2px solid #2ecc71 !important;\r\n} */\r\n\r\n.switch {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 50px;\r\n  height: 24px;\r\n}\r\n\r\n.switch input {\r\n  opacity: 0;\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\n.slider {\r\n  position: absolute;\r\n  cursor: pointer;\r\n  background-color: #ccc;\r\n  border-radius: 24px;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  transition: 0.4s;\r\n}\r\n\r\n.slider:before {\r\n  position: absolute;\r\n  content: \"\";\r\n  height: 18px;\r\n  width: 18px;\r\n  left: 3px;\r\n  bottom: 3px;\r\n  background-color: white;\r\n  border-radius: 50%;\r\n  transition: 0.4s;\r\n}\r\n\r\ninput:checked + .slider {\r\n  background-color: #4caf50;\r\n}\r\n\r\ninput:checked + .slider:before {\r\n  transform: translateX(26px);\r\n}\r\n\r\n.product-image {\r\n  max-width: 100%;\r\n  max-height: 100%;\r\n  text-align: 'center';\r\n  object-fit: 'cover';\r\n  border-radius: 4;\r\n  cursor: 'pointer';\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
